"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Font = void 0;
var rpdf_renderer_1 = require("@surge-global-engineering/rpdf-renderer");
Object.defineProperty(exports, "Font", { enumerable: true, get: function () { return rpdf_renderer_1.Font; } });
//# sourceMappingURL=font.js.map